module.exports = __webpack_public_path__ + "static/media/pizzaPepperoni.e5c5f796.jpg";